import { useUser } from "../../../contexts/UserContext/UserContext";

/** @returns {boolean} `true` when per-car pricing is active (`pricingMode === 'car'`). */
const useCarPricingMode = () => {
    const { myCompanyData } = useUser();
    const mode = myCompanyData?.preferences?.pricingMode === "category" ? "category" : "car";
    return mode === "car";
};

export default useCarPricingMode;
